import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchDashboardReport, fetchRatingData } from "../../actions/summary";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import moment from "moment";
import AccessPage from "../Shared/accessPage";
import Splinechart from "../common/splinechart";
import Loader from "../Shared/loader";
import lookLikeImg from "../../assets/images/Public-Domain--Streamline-Sharp.png";
import rougeMobileImg from "../../assets/images/Iphone--Streamline-Sharp.png";
import socialMediaImg from "../../assets/images/Heart-Square--Streamline-Sharp.png";
import brandMentionImg from "../../assets/images/Help-Question-2--Streamline-Sharp.png";
import seoPoisoningImg from "../../assets/images/Help-Question-2--Streamline-Sharp.png";

var Model = require("./model");

const BrandDashboard = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isModal, setModal] = useState('');
  const [graphTime, setGraphTime] = useState('');
  const vendorName = sessionStorage.getItem('vendorName');  
const vendorId = sessionStorage.getItem('vendorId');

const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
        return orgId;
    } else {
        return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
});
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  // Move useSelector declarations before useEffect hooks
  let summary = useSelector((state) => state?.summary?.dashboardSummary);
  let summaryLoading = useSelector((state) => state?.summary?.loading);
  let ratingData = useSelector((state) => state?.summary?.ratingData);

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
      if (sessionStorage.getItem('vendorId')) {
        clientName = sessionStorage.getItem('vendorName')
      } else {
        clientName = JSON.parse(localStorage.getItem("OrgName"));
      }
  }

  useEffect(() => {
    if (id) {
      fetchDashboardReport(id, "Brand", dispatch);
    } else {
      fetchDashboardReport(id, "Brand", dispatch);
    }
  }, [id]);

  // Add debugging logs
  useEffect(() => {
  }, [summaryLoading, summary, ratingData]);
  
  useEffect(() => {
    if (id) {
      fetchRatingData(id, graphTime, dispatch);
    }
  }, [id, graphTime]);

  // Transform the data into valid x,y coordinates
  const prepareChartData = () => {
    if (!ratingData?.ratings || !Array.isArray(ratingData.ratings)) return { values: [], dates: [] };

    const validData = ratingData.ratings
      .filter(row => row?.createdAt && row?.brandSecuritySecurityImpact !== undefined)
      .map(row => ({
        value: Number(row.brandSecuritySecurityImpact) || 0,
        date: moment(row.createdAt).format("DD-MM-YYYY")
      }));

    return {
      values: validData.map(point => point.value),
      dates: validData.map(point => point.date)
    };
  };

  const chartData = prepareChartData();
  const hasValidChartData = chartData.values.length > 0 && chartData.dates.length > 0;

  // Get total score from rating data
  const totalScore = ratingData?.totalScoreDashboard?.brandSecuritySecurityImpact || 0;

  // Debug logging

  const generateReport = () => {
    if (loading) return;

    setLoading(true);
    const data = {
      id: id,
      asm: 'brand'
    };
    
    Model.default.generateReport(data)
      .then((response) => {
        if (!response.error) {
          try {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${clientName?.replace(/\s+/g, '-') || 'report'}-Brand.docx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } catch (e) {
            // console.error removed
          }
        }
      })
      .catch(error => {
        // console.error removed
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getArrow = (val) => {
    if (val > 0) return "fa fa-arrow-up fa-1x arrowRed";
    else return "fa fa-arrow-down fa-1x arrowGreen";
  };
  // End of generate grade for danglong domains


  return (
    <div className="container-fluid">
      <AccessPage></AccessPage>
      {/* {(summaryLoading || loading) && (
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      )} */}
      {!summaryLoading && !loading && !summary && (
        <div className="text-center">
          <Loader />
        </div>
      )}
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Summary</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                  <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li className="breadcrumb-item active" aria-current="page" style={{ color: 'white' }}>
                  Brand Security Details
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
          <span
              className="btn btn-sm btn-primary mr-1 download-report"
              onClick={() => generateReport()}
            >
              Download Report
            </span>
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-9">
          <div className="card">
            <div className="body" style={{ minHeight: "380px" }}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6>Brand Security Health Tracker</h6>
                    <select 
                      className="form-control" 
                      style={{ width: 'auto', backgroundColor: '#fff', color: 'white', border: '1px solid #444' }}
                      onChange={(e) => {
                        setGraphTime(e.target.value);
                      }}
                    >
                      <option value="">Select Time Period</option>
                      <option value="7days">Last 7 days</option>
                      <option value="1month">Last 30 days</option>
                      <option value="3months">Last 3 months</option>
                      
                    </select>
                  </div>
                  {hasValidChartData && (
                    <Splinechart 
                      value={chartData.values}
                      date={chartData.dates}
                      name={`Brand Security Health Score: ${totalScore}`}
                      color="#08283f"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card">
            <div className="body" style={{ minHeight: "380px" }}>
              <h6>Top Issues</h6>
              <div className="list-group">
                {summary?.issueArray?.slice(0, 3)?.map((row) => (
                  <Link
                    to={row?.link}
                    className="list-group-item list-group-item-action list-group-item-newUpdate"
                    style={{ color: "white" }}
                  >
                    {row?.msg}
                  </Link>
                ))}
                {summary?.issueArray?.length > 3 &&
                  (
                    <span className="text-center mt-3"
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex"
                      }}
                    >
                      <a
                        onClick={() => {
                          setModal('Form Wizard modal')
                        }}
                        style={{
                          float: "right",
                          color: "#fff",
                        }}
                        className="btn btn-primary"
                      >
                        <i
                          className="fa fa-file-excel-o"
                          style={{ color: "#fff" }}
                        ></i>{" "}
                        View All
                      </a>
                    </span>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {id && (
        <>
          <div className="row clearfix">
            <div className="col-sm-3">
              <span className="card">
                <Link  
                to={`/look-alike${vendorId ? '/vendor/' + vendorId : ''}`}
                >
                  <div className="card w_card3 Dcards" style={{ cursor: "pointer" }}>
                    <div className="body">
                      <div className="text-center">
                        <span className="iconBoxDashboard">
                        <img src={lookLikeImg} className="img-fluid" />
                        </span>
                        <h5 className="m-t-20 mb-0">
                          {summary?.DomainSquatting|| 0}
                        </h5>
                        <p className="text-muted1">Look-alike Domains</p>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div>
                        <span className="text-muted1">
                          {!(summaryLoading || loading) ? (
                            <span className="dashboardFirstHeading">
                              {summary?.lookaLikeScanDifference &&
                                summary?.lookaLikeScanDifference !== 0 ? (
                                <i
                                  className={getArrow(
                                    summary?.lookaLikeScanDifference
                                  )}
                                ></i>
                              ) : (
                                ""
                              )}
                              {Math.abs(summary?.lookaLikeScanDifference || 0)}{" "}
                              v/s last scan
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </span>
            </div>
            <div className="col-sm-3">
              <span className="card">
                <Link
                to={`/mobile-apps${vendorId ? '/vendor/' + vendorId : ''}`}
                >
                  <div className="card w_card3 Dcards" style={{ cursor: "pointer" }}>
                    <div className="body">
                      <div className="text-center">
                      <span className="iconBoxDashboard">
                        <img src={rougeMobileImg} className="img-fluid" />
                        </span>
                        <h5 className="m-t-20 mb-0">
                          {summary?.FakeApps || 0}
                        </h5>
                        <p className="text-muted1">Rogue Mobile Applications</p>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div>
                        <span className="text-muted1">
                          {!(summaryLoading || loading) ? (
                            <span className="dashboardFirstHeading">
                              {summary?.rouguemobileScanDifference &&
                                summary?.rouguemobileScanDifference !== 0 ? (
                                <i
                                  className={getArrow(
                                    summary?.rouguemobileScanDifference
                                  )}
                                ></i>
                              ) : (
                                ""
                              )}
                              {Math.abs(
                                summary?.rouguemobileScanDifference || 0
                              )}{" "}
                              v/s last scan
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </span>
            </div>
            <div className="col-sm-3">
              <span className="card">
                <Link
                to={`/social-media${vendorId ? '/vendor/' + vendorId : ''}`}
                >
                  <div className="card w_card3 Dcards" style={{ cursor: "pointer" }}>
                    <div className="body">
                      <div className="text-center">
                      <span className="iconBoxDashboard">
                        <img src={socialMediaImg} className="img-fluid" />
                        </span>
                        <h5 className="m-t-20 mb-0">
                          {summary?.SocialMedia || 0}
                        </h5>
                        <p className="text-muted1">Social Media Profiles</p>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div>
                        <span className="text-muted1">
                          {!(summaryLoading || loading) ? (
                            <span className="dashboardFirstHeading">
                              {summary?.sociailprofileScanDifference &&
                                summary?.sociailprofileScanDifference !== 0 ? (
                                <i
                                  className={getArrow(
                                    summary?.sociailprofileScanDifference
                                  )}
                                ></i>
                              ) : (
                                ""
                              )}
                              {Math.abs(
                                summary?.sociailprofileScanDifference || 0
                              )}{" "} v/s last scan
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </span>
            </div>
            <div className="col-sm-3">
              <span className="card">
                <Link
                  to={
                    `/brand-mentions${vendorId ? '/vendor/' + vendorId : ''}`
                  }
                >
                  <div className="card w_card3 Dcards" style={{ cursor: "pointer" }}>
                    <div className="body">
                      <div className="text-center">
                      <span className="iconBoxDashboard">
                        <img src={brandMentionImg} className="img-fluid" />
                        </span>
                        <h5 className="m-t-20 mb-0">
                          {summary?.brandMention || 0}
                        </h5>
                        <p className="text-muted1">Brand Mentions</p>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div>
                        {!(summaryLoading || loading) ? (
                        <span className="dashboardFirstHeading">
                          {summary?.brandMentionScanDifference &&
                                summary?.brandMentionScanDifference !== 0 ? (
                                <i
                                  className={getArrow(
                                    summary?.brandMentionScanDifference
                                  )}
                                ></i>
                              ) : (
                                ""
                              )}
                          {Math.abs(
                          summary?.brandMentionScanDifference || 0
                          )}{" "} v/s last scan
                        </span>
                        ) : (
                         ""
                        )}
                      </div>
                    </div>
                  </div>
                </Link>
              </span>
            </div>
            <div className="col-sm-3">
              <span className="card">
                <Link
                  to={
                    `/seo-poisoning${vendorId ? '/vendor/' + vendorId : ''}`
                  }
                >
                  <div className="card w_card3 Dcards" style={{ cursor: "pointer" }}>
                    <div className="body">
                      <div className="text-center">
                      <span className="iconBoxDashboard">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#08283f"/>
                          <path d="M12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6ZM12 16C9.79 16 8 14.21 8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 14.21 14.21 16 12 16Z" fill="#08283f"/>
                          <path d="M12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" fill="#08283f"/>
                          <path d="M7 7L9 9" stroke="#08283f" strokeWidth="2" strokeLinecap="round"/>
                          <path d="M15 15L17 17" stroke="#08283f" strokeWidth="2" strokeLinecap="round"/>
                          <path d="M15 7L17 9" stroke="#08283f" strokeWidth="2" strokeLinecap="round"/>
                          <path d="M7 15L9 17" stroke="#08283f" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        </span>
                        <h5 className="m-t-20 mb-0">
                          {summary?.seoPoisoning || 0}
                        </h5>
                        <p className="text-muted1">Seo Poisoning</p>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div>
                        {!(summaryLoading || loading) ? (
                        <span className="dashboardFirstHeading">
                          {summary?.seoPoisoningScanDifference &&
                                summary?.seoPoisoningScanDifference !== 0 ? (
                                <i
                                  className={getArrow(
                                    summary?.seoPoisoningScanDifference
                                  )}
                                ></i>
                              ) : (
                                ""
                              )}
                          {Math.abs(
                          summary?.seoPoisoningScanDifference || 0
                          )}{" "} v/s last scan
                        </span>
                        ) : (
                         ""
                        )}
                      </div>
                    </div>
                  </div>
                </Link>
              </span>
            </div>
          </div>
        </>
      )}
      <div
        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Top Issues
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal("")}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div className="card">
                <div className="body">
                  <div className="list-group">
                    {summary?.issueArray?.map((row) => (
                      <Link
                        to={row?.link}
                        className="list-group-item list-group-item-action list-group-item-newUpdate"
                        style={{ color: "white" }}
                      >
                        {row?.msg}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BrandDashboard;
